import { message } from "antd";
import { CommissionAdminAPI } from "./type";
import { API_URL, API_USER_URL } from "@/env";

const API_USE = API_URL || '';

async function getCommissionList(
    user_id?: number,
    search?: string,
    start_date?: string,
    end_date?: string,
    status?: string,
    is_priority?: number,
    limit?: number,
    page?: number
): Promise<CommissionAdminAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const queryParams = new URLSearchParams();
        if (user_id !== undefined) queryParams.append('user_id', user_id.toString());
        if (search) queryParams.append('search', search);
        if (start_date) queryParams.append('start_date', start_date);
        if (end_date) queryParams.append('end_date', end_date);
        if (status) queryParams.append('status', status);
        if (is_priority && is_priority !== undefined) queryParams.append('is_priority', is_priority.toString());
        if (limit !== undefined) queryParams.append('per_page', limit.toString());
        if (page !== undefined) queryParams.append('page', page.toString());
        const response = await fetch(`${API_USE}/api/v1/be/admin/commissions?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching commissions list');
        }
        const data = await response.json();
        return data as CommissionAdminAPI;
    } catch (error) {
        console.error('Failed to fetch commissions list:', error);
        throw error;
    }
}

async function approveCommission(id: number, transaction_image: File): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const formData = new FormData();
        formData.append('id', id.toString());
        formData.append('transaction_image', transaction_image);
        console.log('FormData entries:');
        formData.forEach((value, key) => {
            console.log(`${key}:`, value);
        });

        const response = await fetch(`${API_USE}/api/v1/be/admin/commissions/approve`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: formData,
        });
        if (!response.ok) {
            throw new Error('Failed to approve commission');
        }
        return await response.json();
    } catch (error) {
        console.error('Failed to approve commission:', error);
        throw error;
    }
}

async function rejectCommission(id: number, message: string): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/commissions/reject`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                id: id,
                reason: message
            })
        });
        if (!response.ok) {
            throw new Error('Failed to reject commission');
        }
        return await response.json();
    } catch (error) {
        console.error('Failed to reject commission:', error);
        throw error;
    }
}

async function settleDaily(start_date: string, end_date: string): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/commissions/settle-daily`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                start_date: start_date,
                end_date: end_date
            })
        });
        if (!response.ok) {
           const errData = await response.json();
           message.error('Error settling daily: ' + (errData.message || 'Unknown error'));
           throw new Error('Failed to settle daily');
        }
        message.success('Daily settlement triggered successfully');
        return await response.json();
    } catch (error) {
        message.error('Failed to settle daily' + (error instanceof Error ? `: ${error.message}` : ''));
        throw error;
    }
}

export {
    getCommissionList,
    approveCommission,
    rejectCommission,
    settleDaily
};